import {
  ConnectAzureBackupAccountApi,
  ConnectAzureRestoreAccountApi,
  ConnectAzureSourceAccountApi,
  ConnectAzureVaultAccountApi,
  ConnectBYOAzureBackupApplicationsApi,
  GetAzureBackupApplicationsApi,
  type Configuration,
} from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/onboarding';

export const onboarding = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const byoappsApi = new ConnectBYOAzureBackupApplicationsApi(config);
  const connectSourceApi = new ConnectAzureSourceAccountApi(config);
  const connectBackupApi = new ConnectAzureBackupAccountApi(config);
  const connectVaultApi = new ConnectAzureVaultAccountApi(config);
  const connectRestoreApi = new ConnectAzureRestoreAccountApi(config);
  const backupAppsApi = new GetAzureBackupApplicationsApi(config);

  return {
    applications: {
      get: (accountType?: 'Source' | 'Scanning' | 'Vault' | 'Restore') => {
        return httpClient.execute(
          backupAppsApi.getAzureBackupApplications.bind(backupAppsApi),
          baseUrl,
          '/azure/backup-applications',
          currentProjectId,
          accountType
        );
      },
      byo: {
        deploy: (data: {
          customerTenantId: string;
          keyVaultAccessServicePrincipalId: string;
          managementAppId: string;
          managementServicePrincipalId: string;
          backupAppId: string;
          backupServicePrincipalId: string;
          secretUrl: string;
        }) => {
          return byoappsApi.connectBYOAzureBackupApplications(
            currentProjectId,
            {
              keyVaultAccessServicePrincipalId:
                data.keyVaultAccessServicePrincipalId,
              managementAppId: data.managementAppId,
              managementServicePrincipalId: data.managementServicePrincipalId,
              backupAppId: data.backupAppId,
              backupServicePrincipalId: data.backupServicePrincipalId,
              secretUrl: data.secretUrl,
              customerTenantId: data.customerTenantId,
            }
          );
        },
      },
    },
    backupAccount: {
      deploy: (data: {
        tenantId: string;
        backupSubscriptionId: string;
        regionName: string;
        adxClusterId: string;
        adxClusterIdentity: string;
        adxClusterUri: string;
        backupIdentityResourceId?: string;
      }) => {
        return connectBackupApi.connectAzureBackupAccount(currentProjectId, {
          tenantId: data.tenantId,
          subscriptionId: data.backupSubscriptionId,
          location: data.regionName,
          adxClusterId: data.adxClusterId,
          adxIdentity: data.adxClusterIdentity,
          adxClusterUri: data.adxClusterUri,
          federatedManagedIdentityResourceId: data.backupIdentityResourceId,
        });
      },
    },
    vaultAccount: {
      deploy: (data: { tenantId: string; vaultSubscriptionId: string }) => {
        return connectVaultApi.connectAzureVaultAccount(currentProjectId, {
          tenantId: data.tenantId,
          subscriptionId: data.vaultSubscriptionId,
        });
      },
    },
    sourceAccount: {
      deploy: (data: {
        tenantId: string;
        sourceSubscriptionId: string;
        sourceManagementGroupId: string;
      }) => {
        return connectSourceApi.connectAzureSourceAccount(currentProjectId, {
          tenantId: data.tenantId,
          subscriptionId: data.sourceSubscriptionId,
          managementGroupId: data.sourceManagementGroupId,
        });
      },
    },
    restoreAccount: {
      deploy: (data: {
        tenantId: string;
        restoreSubscriptionId: string;
        restoreResourceGroupName?: string;
        location: string;
      }) => {
        return connectRestoreApi.connectAzureRestoreAccount(currentProjectId, {
          tenantId: data.tenantId,
          subscriptionId: data.restoreSubscriptionId,
          resourceGroupName: data.restoreResourceGroupName,
          location: data.location,
        });
      },
    },
  };
};
